import { DateTime } from 'luxon'

// Formats in Luxon's default zone — the browser's own local zone. `locale`
// (e.g. a site's language) overrides the browser's language for month names.
export function formatLocalTime(iso, now = DateTime.local(), locale = null) {
  let time = DateTime.fromISO(iso)
  if (locale) time = time.setLocale(locale)

  if (time.hasSame(now, 'day')) return time.toFormat('hh:mm a')
  if (time.hasSame(now, 'year')) return time.toFormat('LLL dd hh:mm a')
  return time.toFormat('LLL dd yyyy hh:mm a')
}
